'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import { ArrowRight, Building2 } from 'lucide-react';
import { useState } from 'react';

type BuyoutHeroVisualProps = {
  source?: string;
  alt: string;
  fallbackTitle: string;
  fallbackLead: string;
};

export function BuyoutHeroVisual({
  source,
  alt,
  fallbackTitle,
  fallbackLead,
}: BuyoutHeroVisualProps) {
  const [failedSource, setFailedSource] = useState<string | null>(null);

  if (source && failedSource !== source) {
    return (
      <Image
        src={source}
        alt={alt}
        fill
        priority
        sizes="(min-width: 1024px) 45vw, 100vw"
        className="object-cover"
        onError={() => setFailedSource(source)}
      />
    );
  }

  return (
    <div className="absolute inset-0 flex items-center justify-center p-8 sm:p-12">
      <div
        className="absolute -right-20 -top-20 h-64 w-64 rounded-full border border-white/15"
        aria-hidden="true"
      />
      <div
        className="absolute -bottom-24 -left-16 h-72 w-72 rounded-full border border-white/15"
        aria-hidden="true"
      />
      <div className="relative w-full max-w-[430px] rounded-2xl border border-white/20 bg-white/10 p-6 text-white shadow-2xl backdrop-blur-sm sm:p-8">
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-white text-primary">
          <Building2 className="h-7 w-7" aria-hidden="true" />
        </div>
        <p className="mt-8 text-2xl font-bold sm:text-3xl">{fallbackTitle}</p>
        <p className="mt-3 text-sm leading-6 text-white/80 sm:text-base">{fallbackLead}</p>
        <div className="mt-8 grid grid-cols-[auto_1fr_auto_1fr_auto] items-center gap-2 text-xs font-semibold sm:gap-3 sm:text-base">
          <span>Správa</span>
          <ArrowRight className="h-4 w-4 justify-self-center text-white/60" aria-hidden="true" />
          <span>Rozhovor</span>
          <ArrowRight className="h-4 w-4 justify-self-center text-white/60" aria-hidden="true" />
          <span className="text-right">Ďalší krok</span>
        </div>
      </div>
    </div>
  );
}
